import { Map, Record } from "immutable";

import { ClassLeaderboard } from "services/classLeaderboardsService/types";

export type ClassLeaderboardsHistoryType = {
  currentLeaderboards: Map<string, ClassLeaderboard>;
  previousLeaderboards: Map<string, ClassLeaderboard>;
};

const defaultClassLeaderboardsHistory: ClassLeaderboardsHistoryType = {
  currentLeaderboards: Map<string, ClassLeaderboard>(),
  previousLeaderboards: Map<string, ClassLeaderboard>()
};

export default class ClassLeaderboardsHistory extends Record(
  defaultClassLeaderboardsHistory
) {}
